import { InfoBox } from "~/components/Backroom/InfoBox";
import ButtonGroup from "../ButtonGroup";
import { CurrentStepProps } from "../getSideMenuItems";
import { SubCategorySelect } from "./SubCategorySelect";
import { ProductTagsSelect } from "./ProductTagsSelect";
import { ProductAttributesSelect } from "./ProductAttributesSelect";
import { Inputs } from "../useUpsertProductForm";

export const categoryPreviewImages = [
  {
    id: "category1",
    title: "Vist på produktoverbliksiden",
    src: "/assets/images/previews/products/product-category/desktop.png",
    alt: "Placering af produktkategorierne på produktoverbliksiden",
    width: 340,
    height: 420,
  },
  {
    id: "category2",
    title: "Vist på produktoverbliksiden på mobil",
    src: "/assets/images/previews/products/product-category/mobil.png",
    alt: "Placering af produktkategorierne på produktoverbliksiden på mobil",
    width: 200,
    height: 500,
  },
];

export const FIELDS: Array<keyof Inputs> = [
  "mainCategory",
  "subCategory",
  "subCategories",
  "productTags",
  "filterValues",
];

export const CategoryStep = (props: CurrentStepProps) => {
  const { stepId, form, onContinue, isEditing, onStepChange, isSubmitting } =
    props;
  const { trigger, reset } = form;

  const beforeContinue = async (options?: { shouldExitEditing?: boolean }) => {
    const isValid = await trigger(FIELDS);

    if (isValid) {
      onContinue(stepId, { visibleFields: FIELDS, ...options });

      // istanbul ignore next
      isEditing && reset({}, { keepValues: true });
    }
  };

  return (
    <>
      <h1 className="text-3xl mb-5">Kategori</h1>
      <p className="mb-12">
        Tilføj en passende kategori til produktet. Kategorien bruges til at
        sortere dine produkter, både på din butiksside og på Butik Danmark
        generelt. Det er også muligt at tilføje butikskategorier, der er unikke
        for din butik og kun bruges til at sortere produkter på din butiksside.
      </p>

      <SubCategorySelect {...props} />
      <ProductTagsSelect {...props} />
      <ProductAttributesSelect {...props} />

      <div className="flex flex-col-reverse lg:flex-col gap-12 mt-32">
        <InfoBox>
          <ul className="list-disc pl-6">
            <li>Du kan ændre kategorien senere.</li>
            <li>
              Den rigtige kategori gør det nemmere for potentielle købere at
              finde dine varer.
            </li>
            <li>
              Har du et ønske om at få oprettet et produktfilter eller en
              kategori, kan du skrive til{" "}
              <a className="underline" href="mailto:kategori@butikdanmark.dk">
                kategori@butikdanmark.dk
              </a>
              .
            </li>
          </ul>
        </InfoBox>
        <ButtonGroup
          isEditing={isEditing}
          onContinue={beforeContinue}
          onStepChange={onStepChange}
          form={form}
          stepId={stepId}
          isSubmitting={isSubmitting}
        />
      </div>
    </>
  );
};
